export default __webpack_public_path__ + "static/speaker3-92b4e8bc7c6a3673b274fbf78e18c55c.jpg";